import { useState } from 'react';

import ContactsMap from '../Courses/CommonComponents/ContactsMap';
import DirectionPreview from '../common/DirectionPreview';
import { SECTIONS } from '../../../constants/courses';
import showDescriptionBG from '../../../assets/directions/showDescriptionBG.png';
import { CursesSections } from '../../../types/common';

import { EventWrapper } from './styles';

const Show = () => {
   const [isModalOpened, setIsModalOpened] = useState(false);

   const handleDirectionAction = () => {
      setIsModalOpened(!isModalOpened);
   }

   return (
      <EventWrapper>
         <DirectionPreview
            bgImage={showDescriptionBG}
            sectionName={SECTIONS.show as CursesSections}
            customTag={'Интервью'}
            handleDirectionAction={handleDirectionAction}
            isButtonDisabled={true}
         />
         <ContactsMap handleButtonClick={handleDirectionAction} />
      </EventWrapper>
   );
};

export default Show;